import { IActionHandler, IDispatcher } from '@dirootie-web/elements-types';
import { useContainer } from './use-container.hook';
import { Action, IAction } from '@dirootie-web/components-types';

export const useDispatcher = ():[
  (action: IAction) => void,
  (action: Action, handler: IActionHandler) => void
] => {
  const container = useContainer();
  const dispatcher = container.resolve<IDispatcher>('dispatcher');
  return [(action:IAction) => dispatcher.dispatch(action), dispatcher.register];
};
